module.exports = {
  title: `dr.log`,
  description: `Blog posted about develop or something.`,
  author: `Dorim Lee`,
  introduction: `개발자 이도림 블로그 입니다.`,
  siteUrl: `https://dolhim.github.io/home`, // Your blog site url
  social: {
    twitter: ``, // Your Twitter account
    github: `dolhim`, // Your GitHub account
    medium: ``, // Your Medium account
    facebook: ``, // Your Facebook account
    linkedin: ``, // Your LinkedIn account
    instagram: ``, // Your Instagram account
  },
  icon: `content/assets/felog.png`, // Add your favicon
  keywords: [`blog`],
  comment: {
    disqusShortName: '', // Your disqus-short-name. check disqus.com.
    utterances: 'dolhim/dolhim.log', // Your repository for archive comment
  },
  configs: {
    countOfInitialPost: 10, // Config your initial count of post
  },
  sponsor: {
    buyMeACoffeeId: 'dolhim',
  },
  share: {
    facebookAppId: '', // Add facebookAppId for using facebook share feature v3.2
  },
  ga: '0', // Add your google analytics tranking ID
}
